import About from "./components/About";
import BackToTop from "./components/BackToTop";
import Footer from "./components/Footer";
import Hero from "./components/Hero";
import Navbar from "./components/Navbar";
import Resume from "./components/Resume";
import Service from "./components/Service";
import Slider from "./components/Slider";
import Work from "./components/Work";
import Contact from "./components/Contact"


function App() {

  return (
    <>
      <div className="row">
        <div className="col-md-12 col-lg-1 col-sm-12">
          <Navbar />
        </div>
        <div className="col-md-12 col-lg-11 col-sm-12" id="content">
          {/* <Route path='/'  /> */}

          <section id="hero">
            <Hero />
          </section>
          <About />
          <Service />
          <Resume />
          <Work />
          <Slider />
          <Contact />

          <BackToTop />
          <Footer />

        </div>
      </div>
    </>
  );
}

export default App;
//
